import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as specs from '../../specs'

export const RESOURCE = {
  payload: {
    description:
      'One spec file in an approval pull request, keyed <pr>_<file path>. It explains the design shared by everything in that pull request.',
    dimension: specs.RESOURCE.payload,
    level: 0,
    name: 'Spec',
    partialId: PartialId.Standard.create('spec'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
